import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Routes from "./routes";

const AppFallback = ({ resetErrorBoundary }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    height="100vh"
    gap={2}
  >
    <Typography variant="h6">Something went wrong</Typography>
    <Button variant="contained" onClick={resetErrorBoundary}>Reload</Button>
  </Box>
);

const App = () => (
  <ErrorBoundary FallbackComponent={AppFallback} onReset={() => window.location.reload()}>
    <Routes />
  </ErrorBoundary>
);

export default App;
